import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const hasNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  container: {
    justifyContent: 'flex-end',
    ...StyleSheet.absoluteFillObject,
    zIndex: 2,
  },
  darkOverlay: {
    flex: 1,
    ...StyleSheet.absoluteFillObject,
    backgroundColor: Colors.overlay,
  },
  blockBox: theme => ({
    backgroundColor: theme.colors.backgroundColorSix,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    paddingBottom: hasNotch ? 55.4 : 35.4,
    paddingHorizontal: 16.2,
    paddingTop: 30,
    textAlign: 'center',
  }),
  closeButton: {
    position: 'absolute',
    right: 16.2,
    top: 30,
    zIndex: 3,
  },
  btnResetAccount: {
    marginTop: 16.6,
    marginBottom: 18.4,
  },
  btnDifferentAccount: {
    borderColor: Colors.light_grey,
    borderWidth: 1,
  },
  txtResetAccount: {
    fontSize: 18.7,
    lineHeight: 24,
    color: Colors.white,
  },
  txtDifferentAccount: theme => ({
    color: theme.colors.text.primary,
    fontSize: 18.7,
    lineHeight: 24,
  }),
  title: theme => ({
    fontSize: 16,
    ...Fonts.type.bold,
    marginBottom: 8,
    lineHeight: 21.8,
    color: theme.colors.text.primary,
  }),
  subTitle: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: 24,
    lineHeight: 34,
    color: theme.colors.text.primary,
    marginVertical: 8,
  }),
  txtEmail: theme => ({
    fontSize: 16.6,
    lineHeight: 21.8,
    ...Fonts.type.bold,
    color: theme.colors.text.primary,
  }),
  txtBlockMessage: theme => ({
    fontSize: 16.6,
    lineHeight: 21.8,
    color: theme.colors.text.primary,
  }),
  message: {
    flexDirection: 'row',
    marginVertical: 8,
  },
  warning: {
    alignSelf: 'center',
  },
});
